var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es462.js.map
